import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useApp } from "../lib/AppContext";

const TIMEZONES = [
  "Europe/Rome", "Europe/Paris", "Europe/Madrid", "Europe/London",
  "Europe/Berlin", "America/New_York", "America/Los_Angeles",
  "Asia/Tokyo", "Asia/Dubai", "UTC",
];

export default function Profile() {
  const { refresh } = useApp();
  const [profile, setProfile] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.getProfile().then(setProfile).catch(() => toast.error("Errore nel caricamento del profilo"));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.updateProfile({
        first_name: profile.first_name || "",
        last_name: profile.last_name || "",
        timezone: profile.timezone || "Europe/Rome",
        locale: profile.locale || "it-IT",
      });
      toast.success("Profilo aggiornato");
      await refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore");
    } finally { setBusy(false); }
  };

  if (!profile) return <div className="pxos-card p-8 opacity-70">Caricamento…</div>;

  return (
    <section className="pxos-card p-6 max-w-xl" data-testid="profile-section">
      <h2 className="font-display text-xl font-semibold">Il tuo profilo</h2>
      <form className="mt-4 space-y-4" onSubmit={save}>
        <div>
          <label className="block text-xs uppercase tracking-widest opacity-70 mb-1">Email</label>
          <input value={profile.email} disabled className="pxos-input opacity-70" data-testid="profile-email" />
          <p className="text-xs opacity-60 mt-1">L'email non è modificabile in questa fase.</p>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <label className="block">
            <span className="text-xs uppercase tracking-widest opacity-70">Nome</span>
            <input value={profile.first_name || ""} onChange={(e) => setProfile({ ...profile, first_name: e.target.value })}
                   className="pxos-input" data-testid="profile-first-name" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest opacity-70">Cognome</span>
            <input value={profile.last_name || ""} onChange={(e) => setProfile({ ...profile, last_name: e.target.value })}
                   className="pxos-input" data-testid="profile-last-name" />
          </label>
        </div>
        <label className="block">
          <span className="text-xs uppercase tracking-widest opacity-70">Fuso orario</span>
          <select value={profile.timezone || "Europe/Rome"}
                  onChange={(e) => setProfile({ ...profile, timezone: e.target.value })}
                  className="pxos-input" data-testid="profile-timezone">
            {TIMEZONES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-widest opacity-70">Lingua</span>
          <select value={profile.locale || "it-IT"}
                  onChange={(e) => setProfile({ ...profile, locale: e.target.value })}
                  className="pxos-input" data-testid="profile-locale">
            <option value="it-IT">Italiano</option>
            <option value="en-US">English</option>
          </select>
        </label>
        <button disabled={busy} className="pxos-btn-primary" data-testid="profile-submit">Salva modifiche</button>
      </form>
    </section>
  );
}
